import { render, staticRenderFns } from "./AboutThree.vue?vue&type=template&id=4953418d&scoped=true&"
import script from "./AboutThree.vue?vue&type=script&lang=js&"
export * from "./AboutThree.vue?vue&type=script&lang=js&"
import style0 from "./AboutThree.vue?vue&type=style&index=0&id=4953418d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4953418d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
